// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function getInputValue(x) {
  return x._0;
}

function getValidationError(x) {
  switch (x.TAG) {
    case "Invalid" :
        return x._1;
    case "Valid" :
    case "Pristine" :
        return /* [] */0;
    
  }
}

exports.getInputValue = getInputValue;
exports.getValidationError = getValidationError;
/* No side effect */
